<template>
    <div class="bill_wrapper">
        <header>
            <van-cell-group>
                <van-cell
                    title="保单号"
                    value="14527003900840351967"
                    size="large"
                    title-class="num_left"
                    value-class="num_right"
                />
                <van-cell
                    title="发票金额（保费）"
                    value="216.00"
                    size="large"
                    title-class="num_left"
                    value-class="price_right"
                />
            </van-cell-group>
        </header>
        <section class="middle">
            <van-cell-group>
                <van-cell
                    title="发票详情"
                    size="large"
                    title-class="details_left"
                    class="num_left_bck"
                />
                <van-cell
                    title="发票类型"
                    value="电子普通发票"
                    size="large"
                    title-class="num_left"
                    value-class="num_right"
                />
            </van-cell-group>
        </section>
        <section class="billType">
            <div class="title_type">
                <van-cell size="large" class="p-right">
                    <div class="flex-box">
                        <div class="title_class">抬头类型</div>
                        <van-radio-group
                            v-model="radio"
                            direction="horizontal"
                            checked-color="#28CC77"
                            @change="toggleType(1)"
                        >
                            <van-radio name="0">企业</van-radio>
                            <van-radio name="1">个人</van-radio>
                        </van-radio-group>
                    </div>
                </van-cell>
            </div>
            <!-- 企业分支 -->
            <template v-if="radio==0">
                <van-cell-group>
                    <div class="flex-box1">
                        <van-cell
                            title="发票抬头"
                            size="large"
                            title-class="num_left"
                            class="flex-width"
                        />
                        <input
                            type="text"
                            placeholder="填写公司发票抬头"
                            class="input_class"
                            v-model="invoiceTitle"
                        />
                    </div>
                </van-cell-group>
                <van-cell-group>
                    <div class="flex-box1">
                        <van-cell
                            title="公司税号"
                            size="large"
                            title-class="num_left"
                            class="flex-width"
                        />
                        <input
                            type="text"
                            placeholder="填写纳税人识别号"
                            class="input_class"
                            v-model="companyInvoiceId"
                        />
                    </div>
                </van-cell-group>
                <van-cell-group>
                    <div class="flex-box1">
                        <van-cell
                            title="电子邮箱"
                            size="large"
                            title-class="num_left"
                            class="flex-width"
                        />
                        <input
                            type="text"
                            placeholder="用于向您发送电子邮件"
                            class="input_class"
                            v-model="emailNum"
                        />
                    </div>
                </van-cell-group>
                <van-cell-group>
                    <div class="flex-box1">
                        <van-cell
                            title="手机号码"
                            size="large"
                            title-class="num_left"
                            class="flex-width"
                        />
                        <input
                            type="text"
                            placeholder="请填写手机号"
                            class="input_class"
                            v-model="telNum"
                        />
                    </div>
                </van-cell-group>
            </template>

            <!-- 个人分支 -->
            <template v-else>
                <van-cell-group>
                    <div class="flex-box1">
                        <van-cell
                            title="发票抬头"
                            size="large"
                            title-class="num_left"
                            class="flex-width"
                        />
                        <input
                            type="text"
                            placeholder="填写个人发票抬头"
                            class="input_class"
                            v-model="invoiceTitle"
                        />
                    </div>
                </van-cell-group>

                <van-cell-group>
                    <div class="flex-box1">
                        <van-cell
                            title="电子邮箱"
                            size="large"
                            title-class="num_left"
                            class="flex-width"
                        />
                        <input
                            type="text"
                            placeholder="用于向您发送电子邮件"
                            class="input_class"
                            v-model="emailNum"
                        />
                    </div>
                </van-cell-group>
                <van-cell-group>
                    <div class="flex-box1">
                        <van-cell
                            title="手机号码"
                            size="large"
                            title-class="num_left"
                            class="flex-width"
                        />
                        <input
                            type="text"
                            placeholder="请填写手机号"
                            class="input_class"
                            v-model="telNum"
                        />
                    </div>
                </van-cell-group>
            </template>
        </section>

        <!-- 底部 -->
        <footer>
            <van-button type="primary" block class="sure" @click="confirm">确认开票</van-button>
        </footer>
    </div>
</template>

<script>
import "./ElectronicBill.less";
import { Cell, CellGroup } from "vant";
import { RadioGroup, Radio } from "vant";
import { Notify, Button } from "vant";
import { isMobile, verifyEmail } from "../../utils/verifyUtils";
import { getElectPolicy } from "../../api/api";

export default {
    name: "ElectronicBill",
    data() {
        return {
            radio: "0", // 0要加引号才能匹配van-radio
            telNum: "", // 手机号码
            emailNum: "", // 电子邮箱
            invoiceTitle: "", // 发票抬头
            companyInvoiceId: "", // 公司税号
            electPolicyUrl:""//跳转链接
        };
    },
    components: {
        "van-cell": Cell,
        "van-cell-group": CellGroup,
        "van-radio-group": RadioGroup,
        "van-radio": Radio,
        "van-button": Button,
    },
    async mounted() {
        const data = await getElectPolicy({
            appNo:"20180706043939945-1074741"//生产环境要给对象
        });
        this.electPolicyUrl=data.electPolicyUrl;
        console.log(data.electPolicyUrl);
    },
    methods: {
        // 切换类型清空表单
        toggleType() {
            this.telNum = "";
            this.emailNum = "";
            this.invoiceTitle = "";
            this.companyInvoiceId = "";
        },
        confirm() {
            // 验证发票抬头
            if (this.invoiceTitle == "") {
                Notify("请输入发票抬头");
                return; // 必须输入return，否则不执行本次Notify函数
            }
            // 验证公司税号
            // 先判断是不是公司类型，个人类型跳过
            if (this.radio == 0) {
                if (this.companyInvoiceId == "") {
                    Notify("请输入公司税号");
                    return;
                }
            }
            // 验证邮箱地址
            if (this.emailNum == "") {
                Notify("请输入电子邮箱地址");
                return;
            } else {
                const mailFlag = verifyEmail(this.emailNum);
                if (!mailFlag) {
                    Notify("邮箱地址格式不正确");
                    return;
                }
            }
            // 验证手机号
            if (this.telNum == "") {
                Notify("请输入手机号码");
                return;
            } else {
                const telFlag = isMobile(this.telNum);
                if (!telFlag) {
                    Notify("手机号码格式不正确");
                    return;
                }
            }
         this.$router.push({path: '' + this.electPolicyUrl});
        },
    },
};
</script>

<style>
</style>